import { createContext } from 'react';
import type { i18n } from 'i18next';
import setupI18next from '../i18n/i18n';

export interface TranslationContextType {
  t: (x: string, y?: object) => string;
  i18n: i18n;
}

const defaultI18n = setupI18next();

const TranslationContext = createContext<TranslationContextType>({
  t: (key) => key,
  i18n: defaultI18n,
});

export default TranslationContext;
